import React, { useMemo, useState } from 'react'
import { Row } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import { ItemView, StyledColList } from 'components/SectionHandler'
import { DataTable } from 'components/DataTable'
import useDelItem from './useDelItem'
import { listCols } from './tableColumns'
import { NEW_RECORD_PATH } from 'config/consts'
import { ReactComponent as DelIcon } from 'media/icons/trashbin.svg'


const AutomationHandler = props => {
	const [listData, setListData] = useState([])
	const [refreshData, setRefreshData] = useState(false)
	const [t] = useTranslation()
	const delHandler = useDelItem({
		...props,
		onItemDeleted: (deletedId) => {
			const { history, location, recordId } = props
			setListData(curr =>
				Array.isArray(curr)
					? curr.filter(item => item.taskId !== deletedId && item.id !== deletedId)
					: curr
			)
			if (recordId && location?.pathname) {
				const clearedPath = location.pathname.replace(`/${recordId}`, '')
				if (history) {
					history.push(clearedPath)
				}
			}
			setRefreshData(true)
		}
	})
	const { history, recordId } = props
	const itemData = useMemo(() => {
		if (!Array.isArray(listData)) {
			return null
		}
		if (recordId === 'neue') {
			return {}
		}
		return listData.find(({ taskId, id }) => String(taskId ?? id) === String(recordId))
	}, [recordId, listData])
	const handleNewRecord = newItemData => {
		const newId = newItemData?.taskId || newItemData?.id
		if (!newId) {
			return
		}
		setRefreshData(true)
		history.push('/optionen/automation/' + newId)
	}
	const onAddRecord = () => history.push('/optionen/automation/' + NEW_RECORD_PATH)
	const handleSelectRecord = id => {
		if (id === recordId) {
			return
		}
		history.push('/optionen/automation/' + id)
	}

	return (
		<Row style={{ height: '100%' }}>
			<StyledColList xs={5}>
				<DataTable
					label={t('options_section.sub_sections.automation')}
					columns={listCols}
					remoteOptions={{
						query: props.sectionData?.listQuery,
						variables: {},
						refreshData: refreshData,
						onDataRefreshed: () => {
							setRefreshData(false)
						},
						onCompleted: res => {
							setListData(res?.cashAssist?.listScheduleTask?.items || [])
						}
					}}
					selectRow={{
						setSelectedRecord: handleSelectRecord,
						selected: recordId
					}}
					rowMenu={[{
						func: delHandler,
						Icon: DelIcon
					}]}
					resizable={true}
					cssHeight
					onAddRecord={onAddRecord}
				/>
			</StyledColList>
			{itemData &&
				<ItemView
					key={recordId}
					{...props}
					skipQuery
					itemData={itemData}
					subsectionProps={{ handleNewRecord, setRefreshData }}
					navBarProps={{ withoutTopMenu: true }}
				/>
			}
		</Row>
	)
}

export default AutomationHandler
